import { MessageCircle } from "lucide-react";
import { SITE } from "@/lib/seo";
import { Seo } from "@/components/Seo";
import { VideoCodeBar } from "@/components/VideoCodeBar";

export default function ShopByCode() {
  return (
    <main data-testid="shop-by-code-page">
      <Seo
        title="Shop by Video Code"
        description="Saw a number on our Instagram Reel, TikTok or Facebook video? Enter the code here to jump straight to that piece — photos, price, sizes and ordering."
        path="/shop-code"
      />
      <section className="max-w-[760px] mx-auto px-5 sm:px-8 py-20 sm:py-28 text-center min-h-[60vh]">
        <div className="overline text-[#B84A3B] mb-3">As Seen In Our Videos</div>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight">Shop the Video</h1>
        <p className="text-sm text-[#6E6E69] font-body mt-4 max-w-md mx-auto leading-relaxed">
          Enter the number from our Instagram Reel, TikTok or Facebook video and we'll take you
          straight to that piece — photos, price, sizes and how to order.
        </p>
        <div className="mt-10">
          <VideoCodeBar large />
        </div>
        <p className="text-xs text-[#6E6E69] font-body mt-10">
          Can't find the code?{" "}
          <a href={`https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent("Hi! I saw a piece in one of your videos — code #")}`}
            target="_blank" rel="noreferrer" data-testid="shop-code-whatsapp"
            className="underline underline-offset-2 hover:text-[#B84A3B] inline-flex items-center gap-1">
            <MessageCircle size={12} /> WhatsApp it to us
          </a>{" "}
          and we'll send you the link.
        </p>
      </section>
    </main>
  );
}
